import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LocalTimeRange } from './LocalTimeRange';
import { UpdatedLocalTimeRange } from './UpdatedLocalTimeRange';
/** The result of removing one or more time ranges from a collection of time ranges. */
export class RemoveLocalTimeRangeResult {
    /**
     * @param deleted Existing time ranges that were deleted, if any.
     * @param updated Existing time ranges that were updated, if any.
     */
    constructor(deleted, updated) {
        this.deleted = deleted;
        this.updated = updated;
    }
}
__decorate([
    Type(() => LocalTimeRange),
    __metadata("design:type", Array)
], RemoveLocalTimeRangeResult.prototype, "deleted", void 0);
__decorate([
    Type(() => UpdatedLocalTimeRange),
    __metadata("design:type", Array)
], RemoveLocalTimeRangeResult.prototype, "updated", void 0);
